import { createTheme, alpha } from "@mui/material";
import type { ThemeMode } from "./stores/theme-store";

export function buildTheme(mode: ThemeMode) {
  const isDark = mode === "dark";
  return createTheme({
    palette: {
      mode,
      primary: { main: isDark ? "#818cf8" : "#4f46e5" },
      background: isDark
        ? { default: "#0b0c10", paper: "#14151b" }
        : { default: "#f7f7fb", paper: "#ffffff" },
      divider: isDark ? "rgba(255,255,255,.08)" : "rgba(15,15,20,.08)",
    },
    shape: { borderRadius: 14 },
    typography: {
      fontFamily: '"Google Sans","Noto Sans Thai",system-ui,sans-serif',
      button: { textTransform: "none", fontWeight: 700 },
    },
    components: {
      MuiCard: {
        styleOverrides: {
          root: {
            backgroundImage: "none",
            border: `1px solid ${isDark ? "rgba(255,255,255,.08)" : "rgba(15,15,20,.08)"}`,
          },
        },
      },
      MuiPaper: {
        styleOverrides: {
          root: { backgroundImage: "none" },
        },
      },
      MuiAppBar: {
        styleOverrides: {
          root: {
            backgroundColor: alpha(isDark ? "#14151b" : "#ffffff", 0.82),
            backdropFilter: "blur(14px)",
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          contained: { boxShadow: "none", "&:hover": { boxShadow: "none" } },
        },
      },
      MuiChip: {
        styleOverrides: {
          label: { fontWeight: 700 },
        },
      },
    },
  });
}
